import {CreateCheckinCycleFormData} from './types';
import {isContentValid} from './content-step.utils';
import {isValidSendTime} from './cadence-step.utils';
import {UI_SELECTED_DAYS_FREQUENCY} from './cadence-frequency';

export type EditableCycleSection = 'basics' | 'content' | 'cadence';

export const getBasicsValidationMessage = (
  data: CreateCheckinCycleFormData,
) => {
  if (!data.cycleName.trim()) return 'Enter a cycle name to continue.';
  if (data.includeScope.length === 0)
    return 'Choose everyone or specific recipients to continue.';
  if (!data.includeScope.includes('everyone')) {
    if (data.includeScope.includes('groups') && !data.includeGroups.length)
      return 'Choose at least one group or team to continue.';
    if (data.includeScope.includes('individuals') && !data.includePeople.length)
      return 'Choose at least one person to continue.';
  }
  if (data.excludeScope.includes('groups') && !data.excludeGroups.length)
    return 'Choose a group to exclude or remove the exclusion.';
  if (data.excludeScope.includes('individuals') && !data.excludePeople.length)
    return 'Choose a person to exclude or remove the exclusion.';
  return null;
};

export const isBasicsSectionValid = (data: CreateCheckinCycleFormData) =>
  getBasicsValidationMessage(data) === null;

export const isContentSectionValid = (data: CreateCheckinCycleFormData) =>
  data.visibility !== '' && isContentValid(data.contentBlocks, data.visibility);

export const isCadenceSectionValid = (data: CreateCheckinCycleFormData) => {
  const {
    frequency,
    selectedDay,
    selectedDays,
    selectedTime,
    oneTimeDate,
    monthlySpecificDay,
    startOption,
    startDate,
    endOption,
    occurrences,
    endDate,
  } = data.cadence;

  if (!frequency) return false;

  const needsTime = frequency !== 'one-time';
  if (needsTime && (!selectedTime.time || !selectedTime.period)) return false;
  if (needsTime && (selectedTime.error || !isValidSendTime(selectedTime.time)))
    return false;
  if (frequency === UI_SELECTED_DAYS_FREQUENCY && selectedDays.length === 0)
    return false;
  if ((frequency === 'weekly' || frequency === 'bi-weekly') && !selectedDay)
    return false;
  if (frequency === 'monthly' && !monthlySpecificDay) return false;
  if (frequency === 'one-time' && startOption === 'specific' && !oneTimeDate)
    return false;
  if (frequency !== 'one-time' && startOption === 'specific' && !startDate)
    return false;
  if (
    frequency !== 'one-time' &&
    endOption === 'after' &&
    (!occurrences || Number.parseInt(occurrences, 10) <= 0)
  )
    return false;
  if (frequency !== 'one-time' && endOption === 'specific' && !endDate)
    return false;

  return true;
};

export const isCycleSectionValid = (
  section: EditableCycleSection,
  data: CreateCheckinCycleFormData,
) => {
  if (section === 'basics') return isBasicsSectionValid(data);
  if (section === 'content') return isContentSectionValid(data);
  return isCadenceSectionValid(data);
};
